import React, { useState, useMemo, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ConfirmationDialog from "../../../ui/ConfirmationDialog.jsx";
import CreateButton from "../molecules/CreateButton.jsx";
import SpaceCard from "./SpaceCard.jsx";
import Input from "../../../ui/input.jsx";
import useEventStore from "../../../.././Store/EventStore.jsx";
import { useTranslation } from "react-i18next";

function SpacesPage() {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [sortBy, setSortBy] = useState("eventDate");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [eventToDelete, setEventToDelete] = useState("");
  const [type, setType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [newSpaceIsOpen, setNewSpaceIsOpen] = useState(false);
  const history = useHistory();

  const {
    fetchEvents,
    handleDeletingEventsOrSpaces,
    events,
    spaces,
    selectEvent,
    fetchFeaturedEvents,
    featuredEvents,
  } = useEventStore();

  useEffect(() => {
    fetchEvents();
    fetchFeaturedEvents();
  }, [fetchEvents, fetchFeaturedEvents]);

  const filteredEvents = useMemo(() => {
    let filtered = [...events];
    if (selectedCategory !== "all") {
      filtered = filtered.filter(
        (event) => event.category === selectedCategory
      );
    }
    filtered = filtered.sort((a, b) => {
      if (sortBy === "eventDate") {
        return new Date(a.eventDate) - new Date(b.eventDate);
      } else if (sortBy === "popularity") {
        return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
      }
      return 0;
    });
    return filtered;
  }, [events, selectedCategory, sortBy]);

  const featuredFilterEvent = featuredEvents.filter(
    (event) => !filteredEvents.some((e) => e.eventName === event.eventName)
  );

  const filteredSpaces = useMemo(() => {
    return spaces.filter((space) =>
      typeof space.spaceName === 'string' && space.spaceName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [spaces, searchQuery]);

  const handleDeleteClick = (type, name) => {
    setEventToDelete(name);
    setType(type);
    setIsPopupVisible(true);
  };

  const handleConfirm = () => {
    handleDeletingEventsOrSpaces(type, eventToDelete);
    setIsPopupVisible(false);
  };

  const handleCancel = () => {
    setIsPopupVisible(false);
  };

  const handleRedirect = (type, giftID, eventName) => {
    selectEvent(type, eventName);
    history.push(`/${type}/${eventName}`);
  };

  return (
    <main className="flex flex-wrap justify-center items-start content-start min-h-dvh mt-12 mx-16">
      <div className="flex justify-center mt-4 w-10/12 items-center">
        <Input
          type="text"
          placeholder={t("search_spaces")}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="mb-2 pl-5 border-green-500 w-full"
        />
      </div>

      <div className="flex flex-wrap justify-center gap-8 mt-8 w-full">
        {filteredSpaces.map((space) => (
          <SpaceCard
            key={space.id}
            spaceData={space}
            onDelete={() => handleDeleteClick("spaces", space.spaceName)}
            onRedirect={handleRedirect}
          />
        ))}

        <ConfirmationDialog
          isOpen={isPopupVisible}
          title={t("delete_space")}
          message={t("delete_confirm_msg")}
          highlightText={eventToDelete}
          confirmText={t("delete")}
          cancelText={t("cancel")}
          subtitle={t("action_undone_msg")}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      </div>
    </main>
  );
}

export default SpacesPage;
